import http from '../services/http';

/**
 * 保险服务
 *
 * @export
 * @class insuranceService
 */
export default class insuranceService {
  constructor($http) {
    this.$http = $http;
  }

  /**
   * 获取保险详情
   *
   * @param {String} case_code 保险号
   * @param {Number} visa_product_id 商品编号
   * @returns
   * @memberof insuranceService
   */
  getInsuranceDetail(caseCode, visaProductId, userOrderId) {
    return http.post('h5/insurance_detail_query', {
      case_code: caseCode,
      visa_product_id: parseInt(visaProductId),
      user_order_id: userOrderId,
    });
  }
}
